import React, { useEffect, useState } from 'react'
import { makeSideBarActive } from '../../utils/EllowUtils'
import SideMenu from '../sideMenu'
import DashboardHeader from '../topbar'
import * as CONSTANTS from '../../utils/CONSTANTS'
import ApplyResourceTable from './applyResource'
import { applyCandidateToJob, getProviderPositions } from './services'
import { useNavigate } from 'react-router-dom'
import mixpanelData from '../../utils/mixpanel'
import NotificationAlert from '../../components/notification'

function ApplyResource() {

  const navigate = useNavigate()

    const menu = makeSideBarActive(CONSTANTS.sideMenu, 1)
    const customerId = localStorage.getItem('customerId') || ''
    const [tableData, setTableData] = useState<any>()
    const resourceData: any = JSON.parse(localStorage.getItem("resourceApplyPositions") || "") || null
    const loginId = localStorage.getItem('loginId')
    const [filterValues, setFilterValues] = useState<any>()
    let BreadcrumsValues = ['Resources', resourceData.name ]
    const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  
    useEffect(() => {
      
        getApplyPositionList('', 1, 25, 'allPosition')
        let filter =  {
          skills: resourceData.skills && resourceData.skills.length > 0 ? resourceData.skills : undefined,
          jobRole:  resourceData.jobRoles,
          range: { from: 0, to: resourceData.experience },
          resourceCost: parseInt(resourceData.rates)      
        }    
     console.log("reso",resourceData);
     
          setFilterValues(filter)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    

    const getApplyPositionList = (
        searchValue: string,
        page: number,
        pageSize: number,
        tab?: string,
        filtering?: any
    ) => {
      
      
      let data = filtering ? filtering : {
        filters: {
          experience: {
              min: 0,
              max: parseInt(resourceData.experience)
          },
          jobRole: resourceData.jobRoles,
          resourceCost: parseInt(resourceData.rates),
          skills: resourceData.skills && resourceData.skills.length > 0 ? resourceData.skills : undefined,
          skillsCombination: false,

      }
      };
      data.filters.positionsToExcludeForCandidateIdProvider = resourceData && resourceData.loginId

      
        getProviderPositions(searchValue, page, pageSize, customerId, tab, data).then((response) => {
            if (response && response.status === 1) {
              setTableData(response.data)
            }
        })
    }
 
  const onSubmit = (value: any) => {
    
    let body = {
      userLoginId: loginId,
      jobId: value[0] && value[0].job_id,
      loginId: [resourceData && resourceData.loginId],
    }
    applyCandidateToJob(body).then((response) => {
      if (response && response.status === 1) {
        mixpanelData('New ML - Candidate applied', {
          'distinct_id': localStorage.getItem('Email') ,
          'Candidate name': response && response.data.candidateDetails[0].CandidateName,
          'Candidate email': response && response.data.candidateDetails[0].candidateEmail,
          'Phone number': response && response.data.candidateDetails[0].phoneNumber,
          'Experience': response && response.data.candidateDetails[0].experience + ' Years',
          'Job role': response && response.data.jobDetails[0].JobRole.name,
          'Expected pay': response && response.data.candidateDetails[0].expectedPay + ' ' + response.data.candidateDetails[0].currencyType + '/' + response.data.candidateDetails[0].billingType,
          'Submitted by': response && response.data.candidateDetails[0].submittedUserName,
          'JobId': response && response.data.jobDetails[0].jobId,
          'Position name': response && response.data.jobDetails[0].position,
          'Company name': response && response.data.jobDetails[0].companyName,
          'Candidate loginid': resourceData && resourceData.loginId,
          'Job type': response && response.data.jobDetails[0].jobType,
        })
        displayNotification()
      }
    })
  }


  const displayNotification = () => {
    setMessage('Profile is shared with ellow team.')
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
     navigate('/resources')
     }, 3000)  
  }


  const searchChange = (search: string) => {
    
    getApplyPositionList(search, 1, 25, 'allPosition')

  }

  const closeTag = (closeValues: any) => {
    // let filter =  {
    //   skills: closeValues.skills,
    //   jobRole: closeValues.jobRole,
    //   range: closeValues.experience && {min: closeValues.experience.min, max: closeValues.experience.max}
    // }    
   setFilterValues(closeValues)
    let value = {
      filters : {
        skills: closeValues.skills,
        skillsCombination: closeValues.skillsCombination !== undefined ? closeValues.skillsCombination.id : undefined,
        jobRole: closeValues.jobRole,
        experience: closeValues.experience
      }
    }
    getApplyPositionList('', 1, 25, 'allPosition',value )
  }


  return (
    <section className="dashboardWrapper">
     {notification && (
          <NotificationAlert
            onClose={() => setNotification(false)}
            closable={true}
            type={'success'}
            icon={true}
          >
            {message}
          </NotificationAlert>
        )}
    <SideMenu menu={menu}/>
    <div className="dashboardContent">
      <DashboardHeader title={BreadcrumsValues} navigateTo="" searchChange={''} />
        <ApplyResourceTable data={tableData} total={tableData && tableData.length} onSubmit={onSubmit} searchChange={searchChange} filtervalues={filterValues} closeTag={closeTag} />        
    </div>
  </section>
  )
}

export default ApplyResource